import { useToast } from 'primevue/usetoast'

export const useAlert = () => {
   const { add } = useToast()

   const alertSucess = (detail, life = 5000) => add({ severity: 'success', detail: detail, life: life })

   const alertError = (error, life = 5000) => add({ severity: 'error', detail: error, life: life })

   const alertWarn = (detail, life = 5000) => add({ severity: 'warn', detail: detail, life: life })

   return {
      alertSucess,
      alertError,
      alertWarn
   }
}
